module.exports = __webpack_public_path__ + "img/9.5cf9f68f.webp";